import update from 'immutability-helper';
import { RootActionTypes } from '../../../stores/types';
import ActionType from '../constants/ActionType';
import { ReturnPolicyFormState } from '../types';

const initialState = {
  submissionError: undefined,
};

export default function returnPolicyFormReducer(
  state: ReturnPolicyFormState = initialState,
  action: RootActionTypes,
) {
  switch (action.type) {
    case ActionType.SubmitReturnPolicyFormError:
      return update(state, {
        submissionError: {
          $set: action.payload,
        },
      });
    case ActionType.ShowReturnPolicyWorksheetRequest:
    case ActionType.SubmitReturnPolicyForm:
      return initialState;
    default:
      return state;
  }
}
